export default "__VITE_ASSET__CClxRQrM__"